import { useMemo } from 'react';
import { Column } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import BillingInitiationControl from "../BillingInitiationControl/BillingInitiationControl";
import { BillingSettingsSection } from "../BillingSettingsSection/BillingSettingsSection";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GetServiceBillingInlineSettingsTID = parentTestId => getTestIds(parentTestId);
export function ServiceBillingInlineSettings(_ref) {
  let {
    service,
    testId,
    agreementData,
    billingInitiation,
    relationshipState,
    isFreshlyAdded,
    disabled,
    disableBillingInitiation,
    disableBillUpfront,
    disableBillingDay,
    showError,
    showBillingSettingsSection = true,
    billingSettingsClassName,
    isReadOnly,
    onChangeService,
    onDayOfMonthChange,
    onDayOfWeekChange,
    onDayOfYearChange,
    onBillUpfrontModeChange,
    onHasError,
    onPausedChange,
    onBillOnAcceptanceChange,
    onStartBillingAtChange
  } = _ref;
  const testIds = useMemo(() => GetServiceBillingInlineSettingsTID(testId), [testId]);
  const isActiveAgreement = agreementData.isActiveAgreement();
  return /*#__PURE__*/_jsxs(Column, {
    testId: testIds.ServiceBillingInlineSettingsTestIds.Root(),
    children: [billingInitiation && /*#__PURE__*/_jsx(BillingInitiationControl, {
      service: service,
      disabled: isReadOnly || disableBillingInitiation || disabled,
      agreementData: agreementData,
      isExistingService: billingInitiation.isExistingService,
      showError: showError,
      testId: testId + 'billing-initiation',
      onChange: onChangeService,
      onBillUpfrontModeChange: onBillUpfrontModeChange,
      isReadOnly: isReadOnly
    }), showBillingSettingsSection && onDayOfMonthChange && onDayOfWeekChange && onDayOfYearChange && onBillUpfrontModeChange && /*#__PURE__*/_jsx(BillingSettingsSection, {
      service: service,
      testId: testId,
      className: billingSettingsClassName,
      isActiveAgreement: isActiveAgreement,
      isFreshlyAdded: isFreshlyAdded,
      isReadOnly: isReadOnly,
      disabled: disabled,
      disableBillUpfront: disableBillUpfront,
      disableBillingDay: disableBillingDay,
      relationshipState: relationshipState,
      onDayOfMonthChange: onDayOfMonthChange,
      onDayOfWeekChange: onDayOfWeekChange,
      onDayOfYearChange: onDayOfYearChange,
      onBillUpfrontModeChange: onBillUpfrontModeChange,
      onHasError: onHasError,
      onPausedChange: onPausedChange,
      onBillOnAcceptanceChange: onBillOnAcceptanceChange,
      onStartBillingAtChange: onStartBillingAtChange
    })]
  });
}